/**
 * Product Popup with Personalization and Cart Functionality
 */

(function() {
    'use strict';

    let currentProductData = null;
    let personalizationNames = [];
    let productVariants = [];
    let selectedVariant = null;

    // Initialize popup functionality
    function initPopup() {
        // Open popup when "Add to Cart" button is clicked
        document.addEventListener('click', function(e) {
            if (e.target.closest('.open-popup-btn')) {
                e.preventDefault();
                const btn = e.target.closest('.open-popup-btn');
                openPopup(btn);
            }
        });

        // Close popup
        const closeBtn = document.getElementById('popup-close-btn');
        const overlay = document.getElementById('custom-popup-overlay');
        
        if (closeBtn) {
            closeBtn.addEventListener('click', closePopup);
        }
        
        if (overlay) {
            overlay.addEventListener('click', function(e) {
                if (e.target === overlay) {
                    closePopup();
                }
            });
        }

        // Quantity change handler
        const quantitySelect = document.getElementById('quantity-select');
        if (quantitySelect) {
            quantitySelect.addEventListener('change', handleQuantityChange);
        }

        // Personalization toggle
        const personalToggle = document.getElementById('personal-toggle');
        if (personalToggle) {
            personalToggle.addEventListener('change', handlePersonalizationToggle);
        }

        // Add to cart button
        const addToCartBtn = document.getElementById('btn-add-to-cart');
        if (addToCartBtn) {
            addToCartBtn.addEventListener('click', handleAddToCart);
        }

        // Bulk enquiry button
        const bulkEnquiryBtn = document.getElementById('btn-bulk-enquiry');
        if (bulkEnquiryBtn) {
            bulkEnquiryBtn.addEventListener('click', handleBulkEnquiry);
        }
    }

    // Open popup and populate data
    function openPopup(btn) {
        const overlay = document.getElementById('custom-popup-overlay');
        if (!overlay) return;

        // Get product data from button attributes
        currentProductData = {
            id: btn.dataset.productId,
            handle: btn.dataset.productHandle,
            title: btn.dataset.productTitle,
            vendor: btn.dataset.productVendor,
            price: parseFloat(btn.dataset.productPrice),
            image: btn.dataset.productImage,
            description: btn.dataset.productDescription,
            variantId: btn.dataset.variantId,
            hasVariants: parseInt(btn.dataset.hasVariants) || 1
        };

        // Parse variants if available
        if (btn.dataset.variants) {
            try {
                productVariants = JSON.parse(decodeURIComponent(btn.dataset.variants));
                
                // Find the selected variant based on the variantId in the button
                const selectedVariantId = parseInt(currentProductData.variantId);
                selectedVariant = productVariants.find(v => v.id === selectedVariantId) || productVariants[0];
            } catch (e) {
                console.error('Error parsing variants:', e);
                productVariants = [];
                selectedVariant = null;
            }
        }

        // Populate popup with product data
        populatePopup();
        
        // Setup variant selector if product has variants
        setupVariantSelector();

        // Show popup
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    // Close popup
    function closePopup() {
        const overlay = document.getElementById('custom-popup-overlay');
        if (overlay) {
            overlay.classList.remove('active');
            document.body.style.overflow = '';
        }
        
        // Reset personalization
        const personalToggle = document.getElementById('personal-toggle');
        if (personalToggle) {
            personalToggle.checked = false;
        }
        handlePersonalizationToggle();
    }

    // Populate popup with product data
    function populatePopup() {
        if (!currentProductData) return;

        // Set product image (use selected variant image if available)
        const productImage = document.getElementById('popup-product-image');
        if (productImage) {
            // Check if we have a selected variant with an image
            if (selectedVariant && selectedVariant.image && selectedVariant.image.src) {
                productImage.src = selectedVariant.image.src;
            } else {
                productImage.src = currentProductData.image;
            }
            productImage.alt = currentProductData.title;
        }

        // Set product title
        const productTitle = document.getElementById('popup-product-title');
        if (productTitle) {
            productTitle.textContent = currentProductData.title;
        }

        // Set variant name (not vendor)
        const productVendor = document.getElementById('popup-product-vendor');
        if (productVendor) {
            if (selectedVariant && selectedVariant.title) {
                productVendor.textContent = selectedVariant.title;
            } else if (productVariants.length > 0 && productVariants[0].title) {
                productVendor.textContent = productVariants[0].title;
            } else {
                productVendor.textContent = '';
            }
        }

        // Set price
        updatePriceDisplay();

        // Set description
        const productDescription = document.getElementById('popup-product-description');
        if (productDescription) {
            productDescription.textContent = currentProductData.description;
            productDescription.style.display = 'grid';
        }
    }

    // Update price display based on quantity
    function updatePriceDisplay() {
        const quantitySelect = document.getElementById('quantity-select');
        const priceRow = document.getElementById('popup-price-row');
        
        if (!quantitySelect || !priceRow || !currentProductData) return;

        const quantity = parseInt(quantitySelect.value);
        const pricePerUnit = currentProductData.price / 100; // Convert from cents
        const totalPrice = pricePerUnit * quantity;

        priceRow.innerHTML = `₹${pricePerUnit.toFixed(2)} <span>X ${quantity} Units</span>`;
    }

    // Handle quantity change
    function handleQuantityChange() {
        updatePriceDisplay();
        
        // If personalization is enabled, regenerate name inputs
        const personalToggle = document.getElementById('personal-toggle');
        if (personalToggle && personalToggle.checked) {
            generatePersonalizationInputs();
        }
    }

    // Handle personalization toggle
    function handlePersonalizationToggle() {
        const personalToggle = document.getElementById('personal-toggle');
        const personalizationInputs = document.getElementById('personalisation-inputs');
        
        if (!personalToggle || !personalizationInputs) return;

        if (personalToggle.checked) {
            generatePersonalizationInputs();
            personalizationInputs.style.display = 'grid';
        } else {
            personalizationInputs.style.display = 'none';
            personalizationInputs.innerHTML = '';
            personalizationNames = [];
        }
    }

    // Generate personalization name inputs based on quantity
    function generatePersonalizationInputs() {
        const quantitySelect = document.getElementById('quantity-select');
        const personalizationInputs = document.getElementById('personalisation-inputs');
        
        if (!quantitySelect || !personalizationInputs) return;

        const quantity = parseInt(quantitySelect.value);
        personalizationInputs.innerHTML = '';

        for (let i = 1; i <= quantity; i++) {
            const inputGroup = document.createElement('div');
            inputGroup.className = 'input-group';
            inputGroup.innerHTML = `
                <label for="name-${i}">Name ${i} <span>*</span></label>
                <input type="text" 
                       id="name-${i}" 
                       class="personalization-name-input" 
                       placeholder="Enter name for unit ${i}"
                       data-index="${i - 1}"
                       value="${personalizationNames[i - 1] || ''}">
            `;
            personalizationInputs.appendChild(inputGroup);
        }

        // Add event listeners to inputs
        const inputs = personalizationInputs.querySelectorAll('.personalization-name-input');
        inputs.forEach(input => {
            input.addEventListener('input', function() {
                const index = parseInt(this.dataset.index);
                personalizationNames[index] = this.value;
            });
        });
    }

    // Handle add to cart
    function handleAddToCart() {
        if (!currentProductData) return;

        const quantitySelect = document.getElementById('quantity-select');
        const personalToggle = document.getElementById('personal-toggle');
        
        if (!quantitySelect) return;

        const quantity = parseInt(quantitySelect.value);
        const isPersonalized = personalToggle && personalToggle.checked;

        // Validate personalization if enabled
        if (isPersonalized) {
            const allNamesFilled = personalizationNames.slice(0, quantity).every(name => name && name.trim() !== '');
            
            if (!allNamesFilled) {
                alert('Please fill in all personalization names before adding to cart.');
                return;
            }
        }

        // Prepare cart data
        const formData = {
            items: [{
                id: currentProductData.variantId,
                quantity: quantity,
                properties: {}
            }]
        };

        // Add personalization data as line item properties
        if (isPersonalized) {
            formData.items[0].properties['Personalized'] = 'Yes';
            formData.items[0].properties['Names'] = personalizationNames.slice(0, quantity).join(', ');
            
            // Add individual names as separate properties
            personalizationNames.slice(0, quantity).forEach((name, index) => {
                formData.items[0].properties[`Name ${index + 1}`] = name;
            });
        }

        if (window.RabitatCart && typeof window.RabitatCart.withCartSections === 'function') {
            formData = window.RabitatCart.withCartSections(formData);
        }

        // Add to cart via Shopify AJAX API
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
            
            // Show success message
            alert(`Successfully added ${quantity} ${quantity > 1 ? 'items' : 'item'} to cart!`);
            
            // Close popup
            closePopup();
            
            if (window.RabitatCart && typeof window.RabitatCart.syncCartAfterAdd === 'function') {
                window.RabitatCart.syncCartAfterAdd(data);
            } else if (typeof window.updateCartCount === 'function') {
                window.updateCartCount();
            }
            
            // Trigger cart drawer open if available
            if (typeof window.openCartDrawer === 'function') {
                window.openCartDrawer();
            }
        })
        .catch(error => {
            console.error('Error adding to cart:', error);
            alert('There was an error adding the product to cart. Please try again.');
        });
    }

    // Handle bulk enquiry
    function handleBulkEnquiry() {
        if (!currentProductData) return;

        const quantitySelect = document.getElementById('quantity-select');
        const quantity = quantitySelect ? parseInt(quantitySelect.value) : 10;

        // Create mailto link or redirect to contact form
        const subject = encodeURIComponent(`Bulk Enquiry: ${currentProductData.title}`);
        const body = encodeURIComponent(`I would like to enquire about bulk ordering:\n\nProduct: ${currentProductData.title}\nQuantity: ${quantity} units\n\nPlease provide more information.`);
        
        window.location.href = `mailto:xyz@headway.com?subject=${subject}&body=${body}`;
    }

    // Setup variant selector - REMOVED, not needed
    function setupVariantSelector() {
        // Hide variant selector box
        const variantSelectBox = document.getElementById('variant-selection-box');
        if (variantSelectBox) {
            variantSelectBox.style.display = 'none';
        }
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPopup);
    } else {
        initPopup();
    }

})();
